import { render, staticRenderFns } from "./GetCodeCoupon.vue?vue&type=template&id=638c2224&"
import script from "./GetCodeCoupon.vue?vue&type=script&lang=js&"
export * from "./GetCodeCoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports